export function Footer() {
  return (
    <footer className="border-t border-white/10 py-8">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-2 px-4 text-center text-xs text-white/40 sm:px-6 lg:px-8">
        <p>CyberTales Learning — Zero-Cost Development Mode (P0). Not for production use.</p>
        <p>© {new Date().getFullYear()} CyberTales Learning. Placeholder content for demonstration purposes.</p>
      </div>
    </footer>
  )
}
